import { Route } from '@angular/router';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { InitialDataResolver } from 'app/app.resolvers';
import { AuthSignInComponent } from './modules/auth/sign-in/sign-in.component';

export const appRoutes: Route[] = [
  { path: '', pathMatch: 'full', redirectTo: 'apps' },
  { path: 'signed-in-redirect', pathMatch: 'full', redirectTo: 'apps' },

  // Auth routes for guests & EmptyLayout
  {
    path: '',
    component: LayoutComponent,
    data: {
      layout: 'empty',
    },

    children: [
      {
        path: 'sign-in',
        component: AuthSignInComponent,
      },
    ],
  },

  // Auth routes for authenticated users & EmptyLayout
  {
    path: '',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    component: LayoutComponent,
    data: {
      layout: 'empty',
    },
    children: [
      {
        path: 'sign-out',
        loadChildren: () => import('app/modules/auth/sign-out/sign-out.routes'),
      },
      {
        path: 'error-404',
        loadChildren: () =>
          import('app/modules/pages/Error/error-404/error-404.routes'),
      },
    ],
  },

  // Auth routes for authenticated users & FullLayouts
  {
    path: '',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    component: LayoutComponent,
    resolve: {
      initialData: InitialDataResolver,
    },
    children: [
      {
        path: 'apps',
        loadChildren: () => import('app/modules/apps/apps.routes'),
      },
      {
        path: 'pages',
        loadChildren: () => import('app/modules/pages/pages.routes'),
      },
      {
        path: 'admin',
        loadChildren: () => import('app/modules/admin/admin.routes'),
      },
    ],
  },
  { path: '**', redirectTo: 'error-404' },
];
